import { SearchFilterForm } from './core/index.js';
import { CONFIG } from './core/config.js';

let initialized = false;

/**
 * Initialize SearchFilterForm when form enters viewport
 */
function initWhenVisible() {
	if (initialized) {
		return;
	}

	const forms = document.querySelectorAll(CONFIG.ELEMENTS.form);

	if (forms.length === 0) {
		return;
	}

	if ('IntersectionObserver' in window) {
		const observer = new IntersectionObserver(
			(entries) => {
				const hasVisibleForm = entries.some((entry) => entry.isIntersecting);

				if (hasVisibleForm && !initialized) {
					initialized = true;
					new SearchFilterForm();
					observer.disconnect();
				}
			},
			{
				rootMargin: '50px',
				threshold: 0.1,
			},
		);

		forms.forEach((form) => {
			observer.observe(form);
		});
	} else {
		document.addEventListener('DOMContentLoaded', () => {
			if (!initialized) {
				initialized = true;
				new SearchFilterForm();
			}
		});
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initWhenVisible);
} else {
	initWhenVisible();
}
